import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import CustomCard from "./CustomCard";
import SplashScreen from "./SplashScreen";

export default function Offline() {
    const navigate = useNavigate();

    return (
        <CustomCard className="w-full md:w-9 shadow-6" navigate="/">
            <div className="flex flex-column justify-content-center gap-3">
                <div className="flex align-items-center justify-content-center text-2xl font-bold">
                    Offline
                </div>
                <div className="flex align-items-center justify-content-center font-normal p-text-secondary text-center">
                    Could not connect to the server.
                </div>
                <i className="flex align-items-center justify-content-center pi pi-exclamation-triangle p-text-secondary text-6xl m-3" />
            </div>
        </CustomCard>
    );
}